// import { ReactNode } from "react";
// import SideBarNavigation from "../Sidebar/Sidebar";

// export function AppBasePage({ children }: { children: ReactNode }) {
//     return (
//         <div className="flex">
//             <div className="w-1/5">
//                 <SideBarNavigation />
//             </div>
//             <div className="flex-1">
//                 <menu></menu>
//                 <header></header>
//                 <main>
//                     {children}
//                 </main>
//             </div>
//         </div>
//     );
// }
import { Box } from "@mui/material";
import { ReactNode } from "react";
import SideBarNavigation from "../Sidebar/Sidebar";

export function AppBasePage({ children }: { children: ReactNode }) {
  return (
    <Box sx={{ display: "flex", height: "calc(100vh - 45px)", overflow: "hidden" }}>
      <Box sx={{ width: "250px", flexShrink: 0 }}>
        <SideBarNavigation />
      </Box>
      <Box
        sx={{
          flex: 1,
          overflow: "auto",
          p: 3,
          pt: 2,
          bgcolor: "#f5f5f5",
          minHeight: "100%",
        }}>
        {children}
      </Box>
    </Box>
  );
}
